export default "__VITE_ASSET__BRTfudIP__"